<template>
  <div class="claim fichaClaim marginLR" v-if="claim">
    <div class="verticalPadding marginBT">
      <div class="title-container">
        <h1 class="titles">
          {{ $t("detalleReclamacion.titulo", { token: claim.token }) }}
          <span class="state">{{
            claim.literalEstado == undefined
              ? claim.estado
              : claim.literalEstado.valor
          }}</span>
        </h1>
        <h1 class="subtitles">
          {{ getFormattedDateShort(claim.fechaAlta) }} /
          {{ getTime(claim.fechaAlta) }}h - {{ $t("detalleReclamacion.tipo") }}
          <span class="claimType">{{
            claim.producto === undefined
              ? ""
              : claim.producto.literalProducto.valor
          }}</span>
        </h1>
      </div>
      <div class="p-grid whitePanel main">
        <div
          class="p-col-12"
          v-if="
            canExecuteTransition(
              claim.listadoTransiciones,
              claim.estado,
              statuses.CANCELADA
            ) ||
            canExecuteTransition(
              claim.listadoTransiciones,
              claim.estado,
              statuses.RECUPERADA
            ) ||
            canExecuteTransition(
              claim.listadoTransiciones,
              claim.estado,
              statuses.SUSPENDIDA
            )
          "
        >
          <h3 class="actions">{{ $t("detalleReclamacion.acciones") }}</h3>
          <p
            v-html="
              $t('detalleReclamacion.estadoActual', {
                estado:
                  claim.literalEstado == undefined
                    ? claim.estado
                    : claim.literalEstado.valor,
              })
            "
          ></p>
        </div>
        <div
          class="p-col-12 closeClaim"
          v-if="
            canExecuteTransition(
              claim.listadoTransiciones,
              claim.estado,
              statuses.CANCELADA
            ) ||
            (canExecuteTransition(
              claim.listadoTransiciones,
              claim.estado,
              statuses.RECUPERADA
            ) &&
              claim.totalPendiente > 0)
          "
        >
          <div class="p-grid">
            <div class="p-col-12 p-md-6">
              <h3>{{ $t("detalleReclamacion.cerrarReclamacion") }}</h3>
              <p>{{ $t("detalleReclamacion.cerrarReclamacionDesc") }}</p>
            </div>
            <div class="closeButtonGroup p-col-12 p-md-6">
              <Button
                v-if="
                  canExecuteTransition(
                    claim.listadoTransiciones,
                    claim.estado,
                    statuses.CANCELADA
                  )
                "
                :label="$t('detalleReclamacion.buttons.desistir')"
                class="p-button"
                @click="openCancelationModalAndRetrieveReasons()"
                :disabled="isSubmitting"
              />
              <Button
                v-if="
                  canExecuteTransition(
                    claim.listadoTransiciones,
                    claim.estado,
                    statuses.RECUPERADA
                  ) && claim.totalPendiente > 0
                "
                :label="$t('detalleReclamacion.buttons.impagoRecuperado')"
                class="cancelDarkButton"
                @click="openRecoverModal()"
                :disabled="isSubmitting"
              />
            </div>
          </div>
        </div>
        <div
          class="p-col-12 closeClaim"
          v-if="
            canExecuteTransition(
              claim.listadoTransiciones,
              claim.estado,
              statuses.SUSPENDIDA
            )
          "
        >
          <div class="p-grid">
            <div class="p-col-12 p-md-6">
              <h3>{{ $t("detalleReclamacion.suspenderReclamacion") }}</h3>
              <p>{{ $t("detalleReclamacion.suspenderReclamacionDesc") }}</p>
            </div>
            <div class="closeButtonGroup p-col-12 p-md-6">
              <Button
                v-if="
                  canExecuteTransition(
                    claim.listadoTransiciones,
                    claim.estado,
                    statuses.SUSPENDIDA
                  )
                "
                :label="$t('detalleReclamacion.buttons.suspender')"
                class="p-button-danger"
                @click="openSuspensionModalAndRetrieveReasons()"
                :disabled="isSubmitting"
              />
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <div
            v-for="currentType in creditorAndDebtor"
            :key="'creditorDebtor_' + currentType.data.id"
          >
            <h3>
              {{ $t("detalleReclamacion.datos", { tipo: currentType.type }) }}
            </h3>
            <p>
              <strong class="titleFichaClaim">{{
                getFullNameByType(
                  currentType.data.nombre,
                  currentType.data.apellidos,
                  currentType.data.razonSocial,
                  esEntidad(currentType.data.tipo)
                )
              }}</strong>
            </p>
            <p>
              {{
                currentType.data.literalTipoUsuarioDetalle
                  ? currentType.data.literalTipoUsuarioDetalle.valor
                  : currentType.data.tipo
              }}
            </p>
            <p>{{ currentType.data.idLegal }}</p>
            <p v-if="currentType.data.contactosActivos.telefono != null">
              {{ currentType.data.contactosActivos.telefono.valor.telefono }}
            </p>
            <p v-if="currentType.data.contactosActivos.email != null">
              {{ currentType.data.contactosActivos.email.valor.email }}
            </p>
            <Direccion
              :contactoDireccion="currentType.data.contactosActivos.direccion"
            />
            <p v-if="currentType.type == 'Acreedor'">
              <strong>IBAN:</strong>
              {{
                claim.iban != null &&
                claim.iban != "" &&
                claim.iban != undefined
                  ? formatIban(claim.iban, " ")
                  : formatIban(currentType.data.iban, " ")
              }}
            </p>
          </div>
          <div>
            <h3>{{ $t("detalleReclamacion.observaciones") }}</h3>
            <p
              v-if="claim.notas == undefined || claim.notas == ''"
              v-html="$t('detalleReclamacion.noObservaciones')"
            ></p>
            <p v-else>{{ claim.notas }}</p>
          </div>
          <div
            v-if="
              claim.envioRequerimientoBBDD &&
              claim.envioRequerimientoBBDD.envioEncontradoBBDD
            "
          >
            <h3>{{ $t("detalleReclamacion.envioRequerimiento") }}</h3>
            <p v-if="claim.envioRequerimientoBBDD.literalCodigoEnvio">
              <b>{{ $t("detalleReclamacion.codigoEnvio") }}: </b
              >{{ claim.envioRequerimientoBBDD.literalCodigoEnvio.valor }}
            </p>
            <span v-if="claim.envioRequerimientoBBDD.estado"
              ><b>{{ $t("detalleReclamacion.estado") }}: </b
              ><span class="status-envio status-badge status-current">{{
                claim.envioRequerimientoBBDD.literalEstadoEnvio.valor
              }}</span></span
            >
            <span
              v-for="documento in claim.envioRequerimientoBBDD.documentosReqInc"
              v-bind:key="documento.filename"
            >
              <Button
                @click.stop="
                  getDocumentoMinio(
                    documento.tipo,
                    documento.clave,
                    documento.filename
                  )
                "
                v-tooltip.bottom="documento.filename"
                class="
                  centerButton
                  p-button
                  p-component
                  p-button-transparent
                  p-button-icon-only
                  p-button-outlined
                  status-envio
                "
                icon="pi pi-file-pdf"
                iconPos="left"
              />
            </span>
            <br />
            <span v-if="claim.envioRequerimientoBBDD.numeroSeguimiento"
              ><b>{{ $t("detalleReclamacion.numeroSeguimiento") }}: </b
              >{{ claim.envioRequerimientoBBDD.numeroSeguimiento }}</span
            >
            <div v-for="file in filesEnvioRequerimiento" :key="file.name">
              <p v-if="file.value">
                <b>{{ file.name }}</b>
                <Button
                  @click.stop="downloadFile(file.fileName, file.value)"
                  v-tooltip.bottom="file.tooltip"
                  class="
                    centerButton
                    p-button
                    p-component
                    p-button-transparent
                    p-button-icon-only
                    p-button-outlined
                    status-envio
                  "
                  icon="pi pi-file-pdf"
                  iconPos="left"
                />
              </p>
            </div>
          </div>
          <div
            v-if="
              claim.envioInclusionBBDD &&
              claim.envioInclusionBBDD.envioEncontradoBBDD
            "
          >
            <h3>{{ $t("detalleReclamacion.envioInclusion") }}</h3>
            <p v-if="claim.envioInclusionBBDD.literalCodigoEnvio">
              <b>{{ $t("detalleReclamacion.codigoEnvio") }}: </b
              >{{ claim.envioInclusionBBDD.literalCodigoEnvio.valor }}
            </p>
            <span v-if="claim.envioInclusionBBDD.estado"
              ><b>{{ $t("detalleReclamacion.estado") }}: </b
              ><span class="status-envio status-badge status-current">{{
                claim.envioInclusionBBDD.literalEstadoEnvio.valor
              }}</span></span
            >
            <span
              v-for="documento in claim.envioInclusionBBDD.documentosReqInc"
              v-bind:key="documento.filename"
            >
              <Button
                @click.stop="
                  getDocumentoMinio(
                    documento.tipo,
                    documento.clave,
                    documento.filename
                  )
                "
                v-tooltip.bottom="documento.filename"
                class="
                  centerButton
                  p-button
                  p-component
                  p-button-transparent
                  p-button-icon-only
                  p-button-outlined
                  status-envio
                "
                icon="pi pi-file-pdf"
                iconPos="left"
              />
            </span>
            <br />
            <span
              v-if="
                claim.envioInclusionBBDD.localizadorProveedor &&
                !claim.envioInclusionBBDD.numeroSeguimiento
              "
              ><b>{{ $t("detalleReclamacion.localizador") }}: </b
              >{{ claim.envioInclusionBBDD.localizadorProveedor }}</span
            >
            <br />
            <span v-if="claim.envioInclusionBBDD.numeroSeguimiento"
              ><b>{{ $t("detalleReclamacion.numeroSeguimiento") }}: </b
              >{{ claim.envioInclusionBBDD.numeroSeguimiento }}</span
            >
            <div v-for="file in filesEnvioInclusion" :key="file.name">
              <p v-if="file.value">
                <b>{{ file.name }}</b>
                <Button
                  @click.stop="downloadFile(file.fileName, file.value)"
                  v-tooltip.bottom="file.tooltip"
                  class="
                    centerButton
                    p-button
                    p-component
                    p-button-transparent
                    p-button-icon-only
                    p-button-outlined
                    status-envio
                  "
                  icon="pi pi-file-pdf"
                  iconPos="left"
                />
              </p>
            </div>
          </div>
          <div v-if="esProductoNotarial">
            <span v-if="tieneActas">
              <h3>{{ $t("detalleReclamacion.actas") }}</h3>
              <ActaProvisionalDefinitiva
                :title="$t('detalleReclamacion.actaProvisional')"
                :listActaDocs="claim.actaProvisionalDoc"
                :estadoEnvio="claim.actaProvisionalBBDD"
              />
              <ActaProvisionalDefinitiva
                :title="$t('detalleReclamacion.actaDefinitiva')"
                :listActaDocs="claim.actaDefinitivaDoc"
                :estadoEnvio="claim.actaDefinitivaBBDD"
              />
            </span>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <h3>{{ $t("detalleReclamacion.datosDeuda") }}</h3>
          <div
            v-for="(debt, idx) in claim.impagos"
            :key="'deuda_' + debt.uuid"
            class="debtCard"
          >
            <div class="debtCardHeader">
              <p class="debtTitle">
                <span class="debtIcon">
                  <i class="pi pi-file-o" />
                </span>
                {{ $t("detalleReclamacion.deuda") }} {{ idx + 1 }}
              </p>
            </div>
            <div class="debtCardBody">
              <div class="p-grid">
                <div class="p-col-6">
                  <InputText
                    class="input"
                    type="text"
                    :value="getFormattedDateShort(debt.fechaVencimiento)"
                    disabled
                  />
                </div>
                <div class="p-col-6">
                  <InputText
                    class="input"
                    type="text"
                    :value="debt.importe | toCurrency('es-ES', claim.divisa)"
                    disabled
                  />
                </div>
                <div class="p-col-12">
                  <div class="p-grid">
                    <div class="p-col-6">
                      <p>{{ $t("detalleReclamacion.pagosParciales") }}</p>
                    </div>
                    <div class="p-col-6 addPaymentContainer">
                      <Button
                        v-if="
                          canExecuteAction(
                            listadoEstadosPredecesoresOrdenImpago,
                            claim.estado
                          )
                        "
                        :label="$t('detalleReclamacion.buttons.pago')"
                        class="addPayment pago"
                        @click="setSelectedDebt(debt)"
                        :disabled="isSubmitting"
                      />
                    </div>
                  </div>
                  <div
                    v-for="(payment, idx) in debt.pagos"
                    :key="'pago_' + idx"
                    class="payments p-grid"
                  >
                    <div class="p-col-3">
                      <p>{{ $t("detalleReclamacion.pago") }} {{ idx + 1 }}</p>
                    </div>
                    <div class="p-col-3">
                      <p>{{ getFormattedDateShort(payment.fechaPago) }}</p>
                    </div>
                    <div class="p-col-6">
                      <p>
                        {{
                          payment.importeRecuperado
                            | toCurrency("es-ES", payment.divisa)
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="pendingDebt p-grid">
                    <div class="p-col-6">
                      <p>{{ $t("detalleReclamacion.pendiente") }}</p>
                    </div>
                    <div class="p-col-6">
                      <p>
                        {{
                          debt.importePendiente === undefined
                            ? ""
                            : debt.importePendiente
                              | toCurrency("es-ES", claim.divisa)
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12">
            <div class="pendingClaim p-grid">
              <div class="p-col-6">
                <p>{{ $t("detalleReclamacion.totalPendiente") }}</p>
              </div>

              <div class="totalPending p-col-6">
                <p>
                  {{
                    claim.totalPendiente === undefined
                      ? ""
                      : claim.totalPendiente | toCurrency("es-ES", claim.divisa)
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="p-col-12">
            <h3>{{ $t("detalleReclamacion.datosBasicos") }}</h3>
            <p>{{ $t("detalleReclamacion.origenDeuda") }}</p>
            <b>{{
              operacion && operacion.literalOrigenDeudaDetalle
                ? operacion.literalOrigenDeudaDetalle.valor
                : operacion.origenDeuda
            }}</b>
          </div>
          <div class="p-col-12">
            <h3>{{ $t("detalleReclamacion.procedimientoJudicial") }}</h3>
            <p
              v-if="claim.viaJudicial"
              v-html="$t('detalleReclamacion.interpuestaDemanda')"
            ></p>
            <p
              v-else
              v-html="$t('detalleReclamacion.noInterpuestaDemanda')"
            ></p>
          </div>
        </div>
        <div class="p-col-12">
          <h3>{{ $t("detalleReclamacion.estadoReclamacion") }}</h3>
          <Checkbox
            v-model="claim.avisos"
            :binary="true"
            @change="checkRecibirAvisos"
          />
          {{ $t("detalleReclamacion.avisos") }}
        </div>

        <div class="p-col-12">
          <DataTable
            :value="claim.traza"
            class="p-datatable-responsive tableExpansion noBorder"
          >
            <Column
              field="fecha"
              :header="$t('detalleReclamacion.fecha')"
              :sortable="false"
            >
              <template #body="slotProps">
                <div class="commentDate">
                  <p>{{ getFormattedDateLong(slotProps.data.fecha) }}</p>
                </div>
              </template>
            </Column>
            <Column
              field="comentario"
              :header="$t('detalleReclamacion.comentarios')"
              :sortable="false"
            >
              <template #body="slotProps">
                {{ slotProps.data.comentario }}
              </template>
            </Column>
            <Column
              field="estado"
              :header="$t('detalleReclamacion.estado')"
              :sortable="false"
            >
              <template #body="slotProps">
                <p>
                  <span class="commentState">{{
                    slotProps.data.literalEstado.valor
                  }}</span>
                </p>
              </template>
            </Column>
          </DataTable>
        </div>

        <div class="p-col-12">
          <h3>{{ $t("detalleReclamacion.mensajes") }}</h3>
          <div class="messagesContainer">
            <div class="messagesListContainer">
              <div
                v-for="(currentMessage, idx) in messages"
                :key="'mensaje_' + currentMessage.id"
                class="p-grid messagesList"
                :class="messages.length - 1 == idx ? 'removeBorderBottom' : ''"
              >
                <div class="p-col-2 logoIcon">
                  <img
                    :src="
                      getAvatar(
                        currentMessage.usuario.genero,
                        currentMessage.usuario.tipo
                      )
                    "
                  />
                </div>
                <div class="p-col-2">
                  <p class="shortDate">
                    {{ getFormattedDateShort(currentMessage.fecha) }}
                  </p>
                  <p class="time">{{ getTime(currentMessage.fecha) }}h</p>
                  <p class="user">
                    {{
                      currentMessage.usuario === undefined
                        ? ""
                        : currentMessage.usuario.nombre +
                          " " +
                          currentMessage.usuario.apellidos
                    }}
                  </p>
                </div>
                <div class="p-col-2">
                  <p
                    v-for="file in currentMessage.archivos"
                    :key="'filemensaje_' + file.id"
                  >
                    <a class="downloadFile" @click="getDocumentoById(file.id)">
                      {{ file.filename }}
                    </a>
                  </p>
                </div>
                <div class="p-col-6">
                  <p class="messageText">{{ currentMessage.mensaje }}</p>
                </div>
              </div>
            </div>
            <Textarea
              class="message"
              v-model="message"
              rows="5"
              cols="30"
              maxlength="800"
              :placeholder="$t('detalleReclamacion.placeholderMensajes')"
            />
            <div class="messageButtonGroup">
              <div class="attachFile">
                <input
                  @change="onFileChange"
                  ref="fileInput"
                  type="file"
                  id="file"
                  class="file"
                  multiple
                />
                <label for="file">
                  <i class="pi pi-paperclip iconSize fileIcon" />
                  {{ $t("detalleReclamacion.adjuntarArchivos") }}
                </label>
              </div>
              <div class="sendMessageButtonGroup">
                <div
                  class="inputCount"
                  :class="message.length == 800 ? 'inputCountDanger' : ''"
                >
                  <span>{{ 800 - message.length }}</span>
                </div>
                <span class="inputSeparator"></span>
                <Button
                  :label="$t('detalleReclamacion.buttons.cancelar')"
                  class="cancelDarkButton p-button-margin"
                  @click="cancelMessage()"
                >
                </Button>
                <Button
                  :label="$t('detalleReclamacion.buttons.enviar')"
                  @click="sendMessage()"
                  :class="
                    !message.length ? 'p-button buttonDisabled' : 'p-button'
                  "
                  :disabled="!message.length"
                >
                </Button>
              </div>
            </div>
            <div class="fileList">
              <div v-for="file in files" :key="'fileList_' + file.filename">
                <span
                  class="cursorPointer"
                  @click="[removeArrayElement(files, file), resetInputFile()]"
                >
                  <i class="pi pi-times iconSize buttonIcon" />
                </span>
                <span class="fileText">{{ file.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      :header="$t('detalleReclamacion.dialog.cancelacion.header')"
      position="top"
      :visible.sync="displayCancelationClaimModal"
      :modal="true"
      :style="{ width: '50vw' }"
      :contentStyle="{ overflow: 'visible' }"
      class="modal"
    >
      <div class="p-grid addPaymentDialog">
        <div class="p-col-12">
          <p>{{ $t("detalleReclamacion.dialog.cancelacion.motivos.title") }}</p>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('common.buttons.no')"
          icon="pi pi-times"
          @click="closeCancelationModal()"
          class="p-button p-button-text cancelDarkButton"
        />
        <Button
          :label="$t('common.buttons.yes')"
          icon="pi pi-check"
          @click="cancelClaim()"
          :disabled="isSubmitting"
          class="p-button"
          autofocus
        />
      </template>
    </Dialog>
    <Dialog
      :header="$t('detalleReclamacion.dialog.suspension.header')"
      position="top"
      :visible.sync="displaySuspensionClaimModal"
      :modal="true"
      :style="{ width: '50vw' }"
      :contentStyle="{ overflow: 'visible' }"
      class="modal"
    >
      <div class="p-grid addPaymentDialog">
        <div class="p-field p-col-12 p-md-6">
          <p class="smallGreyText marginB5Px">
            {{ $t("detalleReclamacion.dialog.suspension.motivos.title") }}
          </p>
          <Dropdown
            v-model="suspensionReason"
            :options="suspensionReasons"
            optionLabel="valor"
            optionValue="clave"
            :placeholder="
              $t('detalleReclamacion.dialog.suspension.motivos.placeholder')
            "
          />
          <br />
          <small
            v-if="suspension.validations.suspensionReason === false"
            class="p-invalid"
            >{{ this.$t("common.formularios.fieldNoValid") }}</small
          >
        </div>
        <div class="p-field p-col-12 p-md-6">
          <p class="smallGreyText marginB5Px">
            {{ $t("detalleReclamacion.dialog.suspension.fechaLimite.title") }}
          </p>
          <InputText
            class="inputSmall"
            type="date"
            v-model="suspensionLimitDate"
            :placeholder="
              $t('detalleReclamacion.dialog.suspension.fechaLimite.placeholder')
            "
          />
          <small
            v-if="suspension.validations.suspensionLimitDate === false"
            class="p-invalid"
            >{{ this.$t("common.formularios.fieldNoValid") }}</small
          >
          <span
            v-if="suspension.validations.suspensionLimitDate === false"
            class="p-invalid"
          >
            <br />
            <small
              class="p-invalid"
              v-for="(literal, idx) in suspension.literalesErrors
                .suspensionLimitDate"
              :key="'errorSuspension' + idx"
            >
              {{ literal }}
            </small>
          </span>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('detalleReclamacion.buttons.cancelar')"
          icon="pi pi-times"
          @click="closeSuspensionModalAndClearReason()"
          class="p-button p-button-text cancelDarkButton"
        />
        <Button
          :label="$t('detalleReclamacion.buttons.aceptar')"
          icon="pi pi-check"
          :disabled="!isSuspendClaimButtonEnabled"
          @click="suspendClaim()"
          class="p-button"
          autofocus
        />
      </template>
    </Dialog>
    <Dialog
      :header="$t('detalleReclamacion.dialog.pagos.header')"
      position="top"
      :visible.sync="displayAddPaymentModal"
      :modal="true"
      :style="{ width: '50vw' }"
      :contentStyle="{ overflow: 'visible' }"
      class="modal"
    >
      <div class="p-grid addPaymentDialog">
        <div class="p-col-12 p-md-6">
          <p class="smallGreyText marginB5Px">
            {{ $t("detalleReclamacion.dialog.pagos.fechaPago") }}
          </p>
          <InputText
            class="inputSmall"
            id="fechaPagoRealizado"
            type="date"
            v-model="newPayment.date"
            :placeholder="$t('detalleReclamacion.dialog.pagos.placeholder')"
          />
          <small
            v-if="newPayment.validations.date === false"
            class="p-invalid"
            >{{ this.$t("common.formularios.fieldNoValid") }}</small
          >
        </div>
        <div class="p-col-12 p-md-6">
          <p class="smallGreyText marginB5Px">
            {{ $t("detalleReclamacion.dialog.pagos.importePago") }}
          </p>
          <InputText
            class="inputSmall"
            id="importePagoRealizado"
            type="number"
            v-model="newPayment.amount"
            :placeholder="
              $t('detalleReclamacion.dialog.pagos.placeholderImporte')
            "
          />
          <small
            v-if="newPayment.validations.amount === false"
            class="p-invalid"
            >{{ this.$t("common.formularios.fieldNoValid") }}</small
          >
        </div>
        <div class="p-col-12 p-md-12">
          <p class="smallGreyText marginB5Px">
            {{ $t("detalleReclamacion.dialog.pagos.observaciones") }}
          </p>
          <Textarea
            id="observaciones"
            style="width: 100%"
            v-model="newPayment.observaciones"
            rows="4"
            cols="100"
          />
        </div>
        <div class="p-col-12 p-md-6">
          <div class="attachFile">
            <input
              @change="onAddPaymentFileChange"
              ref="addPaymentFileInput"
              type="file"
              id="addPaymentFile"
              class="file"
              multiple
            />
            <label for="addPaymentFile">
              <i class="pi pi-paperclip iconSize fileIcon" />
              {{ $t("detalleReclamacion.adjuntarArchivos") }}
            </label>
          </div>
          <div class="fileList">
            <div
              v-for="file in newPayment.files"
              :key="'pagoFile_' + file.filename"
            >
              <span
                class="cursorPointer"
                @click="
                  [
                    removeArrayElement(newPayment.files, file),
                    resetAddPaymentInputFile(),
                  ]
                "
              >
                <i class="pi pi-times iconSize buttonIcon" />
              </span>
              <span class="fileText">{{ file.name }}</span>
            </div>
          </div>
          <small
            v-if="newPayment.validations.filenamePagoParcial === false"
            class="p-invalid"
            >{{
              $t("detalleReclamacion.dialog.pagos.validaciones.archivo")
            }}</small
          >
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('detalleReclamacion.buttons.cancelar')"
          icon="pi pi-times"
          @click="closeAddPaymentModalAndClearNewPayment()"
          class="p-button p-button-text cancelDarkButton"
        />
        <Button
          :label="$t('detalleReclamacion.buttons.aceptar')"
          icon="pi pi-check"
          :disabled="!isAddPaymentButtonEnabled"
          @click="addPayment()"
          class="p-button"
          autofocus
        />
      </template>
    </Dialog>
    <Dialog
      :header="$t('detalleReclamacion.dialog.recuperar.header')"
      position="top"
      :visible.sync="displayAddRecoverModal"
      :modal="true"
      :style="{ width: '50vw' }"
      :contentStyle="{ overflow: 'visible' }"
      class="modal"
    >
      <div class="p-grid addPaymentDialog">
        <div class="p-col-12">
          <p>{{ $t("detalleReclamacion.dialog.recuperar.motivos.title") }}</p>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('common.buttons.cancel')"
          icon="pi pi-times"
          class="p-button p-button-text cancelDarkButton"
          @click="closeRecoverModal"
        />
        <Button
          :label="$t('common.buttons.confirm')"
          icon="pi pi-check"
          @click="recoverClaim()"
        />
      </template>
    </Dialog>
    <div class="layout-content">
      <Toast />
    </div>
  </div>
</template>

<script>
import {
  QUERY_DETALLE_RECLAMACION,
  MUTATION_ALTA_RECLAMACION_MENSAJE,
  QUERY_LISTADO_MENSAJES_RECLAMACION,
  BOTONERA_ESTADOS_POSIBLES_PARA_EJECUTAR_ACCION,
  MUTATION_SUSPEND_CLAIM,
  MUTATION_CANCEL_CLAIM,
  MUTATION_RECOVER_CLAIM,
  QUERY_LISTADO_MOTIVOS_SUSPENSION,
  BOTONERA_ACCIONES_PAGO_PARCIAL_IMPAGO,
  MODIFICAR_AVISOS_FLAG,
} from "@/graphQLQueries/ReclamacionQueries";
import {
  ESTADOS,
  ACCIONES,
  MOTIVOS_CANCELACION,
  PRODUCTOS,
} from "@/resources/constants";
import DatesMixin from "@/utils/dates";
import IbanMixin from "@/utils/iban";
import FilesMixin from "@/utils/files";
import DownloadsMixin from "@/utils/downloads";
import RoutesMixin from "@/utils/routes";
import CurrencyMixin from "@/utils/currency";
import ActionsMixin from "@/utils/actions";
import MessagesMixin from "@/utils/messages";
import StringsMixin from "@/utils/strings";
import UsersMixin from "@/utils/users";
import Direccion from "@/components/portal-cliente/Utils/Direccion.vue";
import ActaProvisionalDefinitiva from "@/components/portal-cliente/Expedientes/ActaProvisionalDefinitiva.vue";

export default {
  name: "Claim",
  mixins: [
    DatesMixin,
    IbanMixin,
    FilesMixin,
    DownloadsMixin,
    CurrencyMixin,
    RoutesMixin,
    ActionsMixin,
    MessagesMixin,
    StringsMixin,
    UsersMixin,
  ],
  components: {
    Direccion: Direccion,
    ActaProvisionalDefinitiva: ActaProvisionalDefinitiva,
  },
  data: () => ({
    claim: {},
    creditorAndDebtor: [],
    operacion: {},
    message: "",
    files: [],
    messages: [],
    altaOK: false,
    displayAddPaymentModal: false,
    newPayment: {
      date: "",
      amount: "",
      files: [],
      filenamePagoParcial: "",
      fileBase64PagoParcial: null,
      observaciones: "",
      validations: {
        filenamePagoParcial: true,
        date: true,
        amount: true,
      },
      errors: [],
    },
    selectedDebt: {},
    statuses: ESTADOS,
    allActions: ACCIONES,
    listadoEstadosPredecesoresOrdenImpago: null,
    displayCancelationClaimModal: false,
    cancellationReason: MOTIVOS_CANCELACION.CANCELACION_CLIENTE,
    displaySuspensionClaimModal: false,
    suspensionReason: "",
    suspensionReasons: [],
    suspensionLimitDate: "",
    codeErrors: {
      newPayment: {
        date: ["5011"],
        amount: ["5007", "5008", "5011"],
        filenamePagoParcial: ["5017"],
      },
      suspension: {
        suspensionLimitDate: ["10007"],
        suspensionReason: ["10006"],
      },
    },
    isSubmitting: false,
    displayAddRecoverModal: false,
    suspension: {
      errors: [],
      literalesErrors: {
        suspensionLimitDate: [],
        suspensionReason: [],
      },
      validations: {
        suspensionLimitDate: true,
        suspensionReason: true,
      },
    },
    cancel: {
      errors: [],
    },
    recover: {
      errors: [],
    },
  }),
  apollo: {
    fichaReclamacion: {
      query: QUERY_DETALLE_RECLAMACION,
      variables() {
        return {
          token: this.$route.params.token,
          idioma: this.$i18n.locale,
        };
      },
      fetchPolicy: "no-cache",
      update(data) {
        if (data && data.reclamacion) {
          this.claim = data.reclamacion;
          this.creditorAndDebtor = [];
          if (this.claim) {
            this.operacion = this.claim.operacion;
            this.addCreditorOrDebtor(this.claim.acreedor, "Acreedor");

            //Si la propia reclamacion tiene contactos, tienen prioridad
            if (this.claim.contactoEmail)
              this.$set(
                this.claim.deudor.contactosActivos,
                "email",
                this.claim.contactoEmail
              );

            if (this.claim.contactoTelefono)
              this.$set(
                this.claim.deudor.contactosActivos,
                "telefono",
                this.claim.contactoTelefono
              );

            if (this.claim.contactoDireccion)
              this.$set(
                this.claim.deudor.contactosActivos,
                "direccion",
                this.claim.contactoDireccion
              );

            this.addCreditorOrDebtor(this.claim.deudor, "Reclamado");
            this.retrieveMessages();
          }
        }
      },
      error(exception) {
        console.error("exception " + exception);
        this.goTo403View();
      },
    },
  },
  methods: {
    search() {
      this.$apollo.queries.fichaReclamacion.refetch();
    },
    onFileChange(e) {
      this.files = Array.from(e.target.files);
    },
    onAddPaymentFileChange(e) {
      this.newPayment.files = Array.from(e.target.files);
      var filePagoParcial = this.newPayment.files[0];
      if (filePagoParcial != null && filePagoParcial != undefined) {
        var reader = new FileReader();
        reader.readAsDataURL(filePagoParcial);
        let self = this;
        reader.onload = function () {
          var filename = filePagoParcial.name;
          if (self.checkFileExtensionPdf(filename)) {
            self.newPayment.filenamePagoParcial = filename;
            self.newPayment.fileBase64PagoParcial = reader.result;
            self.newPayment.validations.filenamePagoParcial = true;
          } else {
            self.newPayment.validations.filenamePagoParcial = false;
          }
        };
        reader.onerror = function (error) {
          console.error(error);
          self.newPayment.filenamePagoParcial = "";
          self.newPayment.fileBase64PagoParcial = null;
        };
      }
    },
    addCreditorOrDebtor(data, type) {
      this.creditorAndDebtor.push({
        data: data,
        type: type,
      });
    },
    cancelMessage() {
      this.message = "";
      this.files = [];
      this.resetInputFile();
    },
    openAddPaymentModal() {
      this.displayAddPaymentModal = true;
    },
    closeAddPaymentModalAndClearNewPayment() {
      this.displayAddPaymentModal = false;
      this.clearNewPayment();
    },
    setSelectedDebt(debt) {
      this.selectedDebt = debt;

      this.openAddPaymentModal();
    },
    addPayment() {
      this.isSubmitting = true;
      this.resetErrorsPayments();
      const ordenPagoImpagoRequest = {
        impagoUuid: this.selectedDebt.uuid,
        tokenImpago: this.selectedDebt.token,
        importe:
          this.newPayment.amount != null &&
          this.newPayment.amount != "" &&
          !isNaN(this.newPayment.amount)
            ? this.newPayment.amount
            : 0,
        divisa: this.claim.divisa,
        filename: this.newPayment.filenamePagoParcial,
        fileBase64: this.newPayment.fileBase64PagoParcial,
        usuarioUuid: this.$store.state.profile.uuid,
        observaciones: this.newPayment.observaciones,
        fechaPago: this.newPayment.date
          ? this.utcTimestamp(this.newPayment.date)
          : null,
        noComisiona: true,
      };
      this.$apollo
        .mutate({
          mutation: BOTONERA_ACCIONES_PAGO_PARCIAL_IMPAGO,
          variables: {
            ordenPagoImpagoRequest,
          },
          update(data) {
            return data;
          },
        })
        .then(() => {
          this.closeAddPaymentModalAndClearNewPayment();
          this.setMessages(
            "success",
            this.$i18n.t("reclamacion.messages.success.pagoParcial"),
            3000
          );
          this.search();
          this.isSubmitting = false;
        })
        .catch((exception) => {
          this.isSubmitting = false;
          this.resetErrorsPayments();
          this.setMessages(
            "error",
            this.$i18n.t("reclamacion.messages.error.pagoParcial"),
            3000
          );
          exception.graphQLErrors.forEach((error) => {
            this.newPayment.errors.push(error.message);
          });
          this.checkPaymentValidationPassed(
            this.newPayment.errors,
            this.codeErrors.newPayment
          );
        });
    },
    clearNewPayment() {
      this.newPayment = {
        date: "",
        amount: "",
        files: [],
        filenamePagoParcial: "",
        fileBase64PagoParcial: null,
        observaciones: "",
        validations: {
          filenamePagoParcial: true,
          amount: true,
          date: true,
        },
        errors: [],
      };
      this.resetErrorsPayments();
      this.resetAddPaymentInputFile();
    },
    resetErrorsPayments() {
      let self = this;
      self.newPayment.errors = [];
      Object.keys(self.newPayment.validations).forEach(function (key) {
        eval("self.newPayment.validations." + key + "= true");
      });
    },
    resetAddPaymentInputFile() {
      this.$refs.addPaymentFileInput.value = null;
    },
    async sendMessage() {
      const base64Files = await this.convertFiles(this.files);

      const sendMessageInputRequest = {
        ficherosAdjuntos: base64Files,
        mensaje: this.message,
        uuidReclamacion: this.claim.uuid,
        uuidUsuario: this.$store.state.profile.uuid,
      };
      this.$apollo
        .mutate({
          mutation: MUTATION_ALTA_RECLAMACION_MENSAJE,
          variables: {
            input: sendMessageInputRequest,
          },
        })
        .then((data) => {
          this.cancelMessage();

          const message = data.data.altaMensajeReclamacion;
          this.messages.push(message);
        })
        .catch(() => {
          this.setMessages(
            "error",
            this.$i18n.t("reclamacion.messages.error.errorGenerico"),
            3000
          );
        });
    },
    retrieveMessages() {
      this.$apollo
        .query({
          query: QUERY_LISTADO_MENSAJES_RECLAMACION,
          variables: {
            criteria: {
              filter: [`reclamacion.uuid~uuid=${this.claim.uuid}`],
              page: 0,
              size: 1000,
              sort: ["fecha"],
            },
          },
        })
        .then((data) => {
          this.messages = data.data.listaMensajeReclamacion.results;
        })
        .catch((error) => {
          console.error(error);
          this.setMessages(
            "error",
            this.$i18n.t("reclamacion.messages.error.errorGenerico"),
            3000
          );
        });
    },
    removeArrayElement(list, value) {
      var idx = list.indexOf(value);

      if (idx !== -1) {
        list.splice(idx, 1);
      }
    },
    resetInputFile() {
      this.$refs.fileInput.value = null;
    },
    suspendClaim() {
      this.resetErrorsSuspension();
      this.isSubmitting = true;
      this.$apollo
        .mutate({
          mutation: MUTATION_SUSPEND_CLAIM,
          variables: {
            usuarioUuid: this.$store.state.profile.uuid,
            tokenReclamacion: this.claim.token,
            motivoSuspension: this.suspensionReason,
            fechaLimite: this.suspensionLimitDate
              ? this.utcTimestamp(this.suspensionLimitDate)
              : null,
          },
        })
        .then(() => {
          this.isSubmitting = false;
          this.closeSuspensionModalAndClearReason();
          this.setMessages(
            "success",
            this.$i18n.t("reclamacion.messages.success.suspend"),
            3000
          );
          this.search();
        })
        .catch((exception) => {
          this.isSubmitting = false;
          this.setMessages(
            "error",
            this.$i18n.t("reclamacion.messages.error.suspend"),
            3000
          );
          exception.graphQLErrors.forEach((error) => {
            this.suspension.errors.push(error.message);
          });
          this.checkSuspensionValidationPassed(
            this.suspension.errors,
            this.codeErrors.suspension
          );
        });
    },
    resetErrorsSuspension() {
      let self = this;
      self.suspension.errors = [];
      self.suspension.literalesErrors.suspensionLimitDate = [];
      self.suspension.literalesErrors.suspensionReason = [];
      Object.keys(self.suspension.validations).forEach(function (key) {
        eval("self.suspension.validations." + key + "= true");
      });
    },
    cancelClaim() {
      this.isSubmitting = true;
      this.$apollo
        .mutate({
          mutation: MUTATION_CANCEL_CLAIM,
          variables: {
            usuarioUuid: this.$store.state.profile.uuid,
            tokenReclamacion: this.claim.token,
            motivoCancelacion: this.cancellationReason,
          },
        })
        .then(() => {
          this.isSubmitting = false;
          this.closeCancelationModal();
          this.setMessages(
            "success",
            this.$i18n.t("reclamacion.messages.success.cancel"),
            3000
          );
          this.search();
        })
        .catch((exception) => {
          this.isSubmitting = false;
          this.setMessages(
            "error",
            this.$i18n.t("reclamacion.messages.error.cancel"),
            3000
          );

          exception.graphQLErrors.forEach((error) => {
            this.cancel.errors.push(error.message);
          });
        });
    },
    recoverClaim() {
      this.isSubmitting = true;
      this.$apollo
        .mutate({
          mutation: MUTATION_RECOVER_CLAIM,
          variables: {
            tokenReclamacion: this.claim.token,
            recuperadoAutomatico: true,
            usuarioUuid: this.$store.state.profile.uuid,
          },
        })
        .then(() => {
          this.isSubmitting = false;
          this.closeRecoverModal();
          this.setMessages(
            "success",
            this.$i18n.t("reclamacion.messages.success.recover"),
            3000
          );
          this.search();
        })
        .catch((exception) => {
          this.isSubmitting = false;
          this.setMessages(
            "error",
            this.$i18n.t("reclamacion.messages.error.recover"),
            3000
          );
          exception.graphQLErrors.forEach((error) => {
            this.recover.errors.push(error.message);
          });
        });
    },
    closeCancelationModal() {
      this.displayCancelationClaimModal = false;
      this.cancel.errors = [];
    },
    closeSuspensionModalAndClearReason() {
      this.displaySuspensionClaimModal = false;
      this.suspension.errors = [];
      this.suspension.literalesErrors.suspensionLimitDate = [];
      this.suspension.literalesErrors.suspensionReason = [];
      this.suspensionReason = "";
      this.suspensionLimitDate = "";
    },
    closeRecoverModal() {
      this.displayAddRecoverModal = false;
      this.recover.errors = [];
    },
    openCancelationModalAndRetrieveReasons() {
      this.displayCancelationClaimModal = true;
    },
    openSuspensionModalAndRetrieveReasons() {
      this.displaySuspensionClaimModal = true;

      this.retrieveSuspensionReasons();
    },
    openRecoverModal() {
      this.displayAddRecoverModal = true;
    },
    retrieveSuspensionReasons() {
      this.$apollo
        .mutate({
          mutation: QUERY_LISTADO_MOTIVOS_SUSPENSION,
          variables: {
            idioma: this.$i18n.locale,
          },
        })
        .then((data) => {
          this.suspensionReasons = data.data.listadoMotivosSuspension;
        })
        .catch(() => {
          this.setMessages(
            "error",
            this.$i18n.t("reclamacion.messages.error.errorGenerico"),
            3000
          );
        });
    },
    getListadoEstadosPermitidosPorAccion(accion) {
      this.$apollo
        .query({
          query: BOTONERA_ESTADOS_POSIBLES_PARA_EJECUTAR_ACCION,
          variables: {
            nombre: accion,
          },
        })
        .then((data) => {
          this.listadoEstadosPredecesoresOrdenImpago =
            data.data.listadoEstadosPredecesores;
        })
        .catch(() => {
          this.listadoEstadosPredecesoresOrdenImpago = null;
        });
    },
    checkPaymentValidationPassed(errors, codeErrors) {
      let self = this;

      if (self) {
        Object.keys(codeErrors).forEach(function (key) {
          if (errors.some((code) => eval("codeErrors." + key).includes(code))) {
            eval("self.newPayment.validations." + key + "= false");
          } else {
            eval("self.newPayment.validations." + key + "= true");
          }
        });
      }
    },
    checkSuspensionValidationPassed(errors, codeErrors) {
      let self = this;
      Object.keys(codeErrors).forEach(function (key) {
        if (errors.some((code) => eval("codeErrors." + key).includes(code))) {
          eval("self.suspension.validations." + key + "= false");
          var codeMessage = errors.find((code) =>
            eval("codeErrors." + key).includes(code)
          );
          if (codeMessage) {
            var literalMessage = self.$i18n.t(
              "acciones.errores." + codeMessage
            );
            eval(
              "self.suspension.literalesErrors." +
                key +
                ".push('" +
                literalMessage +
                "')"
            );
          }
        } else {
          eval("self.suspension.validations." + key + "= true");
        }
      });
    },
    checkRecibirAvisos() {
      this.$apollo
        .mutate({
          mutation: MODIFICAR_AVISOS_FLAG,
          variables: {
            token: this.claim.token,
            avisos: this.claim.avisos,
          },
          update(data) {
            return data;
          },
        })
        .then((data) => {
          this.claim.avisos = data.data.configurarReclamacion.avisos;
          this.setMessages(
            "success",
            this.$i18n.t("reclamacion.messages.success.avisos"),
            3000
          );
        })
        .catch(() => {
          this.setMessages(
            "error",
            this.$i18n.t("reclamacion.messages.error.avisos"),
            3000
          );
        });
    },
    downloadFile(fileName, file) {
      this.download(fileName, file, document);
    },
    getFiles(estadoEnvio) {
      return [
        {
          name: this.$t("estadoEnvio.certPdf"),
          fileName: this.$t("estadoEnvio.certPdfFileName"),
          tooltip: this.$t("estadoEnvio.descargarCertPdf"),
          value: this.sanitizeBase64(estadoEnvio.certPdf),
        },
        {
          name: this.$t("estadoEnvio.acuseRecibo"),
          fileName: this.$t("estadoEnvio.acuseReciboFileName"),
          tooltip: this.$t("estadoEnvio.descargarAcuseRecibo"),
          value: this.sanitizeBase64(estadoEnvio.stampedContent),
        },
        {
          name: this.$t("estadoEnvio.postalCert"),
          fileName: this.$t("estadoEnvio.postalCertFileName"),
          tooltip: this.$t("estadoEnvio.descargarPostalCert"),
          value: this.sanitizeBase64(estadoEnvio.postalCert),
        },
        {
          name: this.$t("estadoEnvio.postalNote"),
          fileName: this.$t("estadoEnvio.postalNoteFileName"),
          tooltip: this.$t("estadoEnvio.descargarPostalNote"),
          value: this.sanitizeBase64(estadoEnvio.postalNote),
        },
      ];
    },
  },
  created() {
    this.getListadoEstadosPermitidosPorAccion(
      this.allActions.ACCION_ORDEN_PAGO_IMPAGO
    );
  },
  mounted() {
    this.altaOK = this.$route.params.altaOK ? this.$route.params.altaOK : false;
    if (this.altaOK) {
      this.setMessages(
        "success",
        this.$i18n.t("reclamacion.messages.success.thankYou"),
        6000
      );
      this.altaOK = false;
    }
  },
  computed: {
    filesEnvioInclusion() {
      return this.getFiles(this.claim.envioInclusionBBDD);
    },
    filesEnvioRequerimiento() {
      return this.getFiles(this.claim.envioRequerimientoBBDD);
    },
    isAddPaymentButtonEnabled() {
      return (
        this.newPayment.date != "" &&
        this.newPayment.amount > 0 &&
        !this.isSubmitting
      );
    },
    isSuspendClaimButtonEnabled() {
      return (
        this.suspensionReason != "" &&
        this.suspensionLimitDate != "" &&
        !this.isSubmitting
      );
    },
    esProductoNotarial() {
      const esNotarial =
        this.claim &&
        this.claim.producto &&
        this.claim.producto.codigoProducto ==
          PRODUCTOS.PRODUCTO_ICIRED_NOTARIAL;
      return esNotarial;
    },
    tieneActas() {
      const tieneActaProvisional =
        this.claim.actaProvisionalDoc &&
        this.claim.actaProvisionalDoc.length > 0;
      const tieneActaDefinitiva =
        this.claim.actaDefinitivaDoc && this.claim.actaDefinitivaDoc.length > 0;

      return tieneActaProvisional || tieneActaDefinitiva;
    },
  },
};
</script>

<style lang="scss" scoped>
.status-envio {
  margin-left: 5px;
}
</style>